// extracted by mini-css-extract-plugin
module.exports = {"rejoinRow":"RejoinVirtualCard_rejoinRow__3lcUW","rejoinColumn":"RejoinVirtualCard_rejoinColumn__20ZhF"};